export default function CTASection() {
  return (
    <section className="relative py-12 sm:py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20customer%20support%20representative%20with%20headset%20in%20modern%20call%20center%20office%2C%20friendly%20smile%2C%20dark%20modern%20background%20with%20green%20tech%20lighting%20accents%2C%20corporate%20technology%20photography%2C%20high%20quality&width=1600&height=600&seq=donnos-cta-01&orientation=landscape"
          alt="Atendimento Donnos"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-donnos-dark/85"></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="max-w-3xl">
          <h2 className="text-xs sm:text-sm font-semibold text-donnos-green uppercase tracking-wider mb-2">ORÇAMENTO RÁPIDO</h2>
          <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 md:mb-4">
            Precisa de uma cotação ou deseja consultar uma ata?
          </h3>
          <p className="text-sm sm:text-base text-gray-300 leading-relaxed mb-6 md:mb-8 max-w-xl">
            Entre em contato conosco e receba seu orçamento em até 24 horas. Nossa equipe está pronta para atender você com as melhores soluções em tecnologia.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap gap-3 md:gap-4 mb-8 md:mb-10">
            <a
              href="#contato"
              className="inline-flex items-center justify-center gap-2 bg-donnos-green hover:bg-donnos-green-dark text-white font-semibold px-5 md:px-6 py-3 rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-file-list-3-line"></i>
              Solicitar orçamento
            </a>
            <a
              href="#atas"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/30 hover:border-white text-white font-semibold px-5 md:px-6 py-3 rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-search-line"></i>
              Consulta de Atas
            </a>
          </div>

          <div className="flex flex-col sm:flex-row flex-wrap gap-4 sm:gap-6">
            <a href="https://wa.me/5511988730909" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white hover:text-donnos-green transition-colors">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center shrink-0">
                <i className="ri-whatsapp-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-gray-400">Suporte</div>
                <div className="text-sm font-medium">11 9 8873-0909</div>
              </div>
            </a>
            <a href="tel:+551145510810" className="flex items-center gap-3 text-white hover:text-donnos-green transition-colors">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center shrink-0">
                <i className="ri-phone-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-gray-400">Comercial</div>
                <div className="text-sm font-medium">11 4551-0810</div>
              </div>
            </a>
            <a href="mailto:contato@donnosvendas.com" className="flex items-center gap-3 text-white hover:text-donnos-green transition-colors">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-gray-400">Email</div>
                <div className="text-sm font-medium">contato@donnosvendas.com</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
